<template>
  <el-dialog :close-on-click-modal="false" class="tx-c" :visible="visible" append-to-body title="费用结算" @close="cancel" width="30rem" top="10vh">
    <el-main style="padding: 10px; height: 20rem">
     
      <div>
        <div style="padding:10px 20px;">
          
          <el-form class="left" ref="info" :rules="rules" :inline="true" :model="detailValue" label-width="7rem">
            <el-row>
               <el-col>
                <el-form-item label="退费金额：" prop="">
                <div>1234元</div>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="退款方式：" prop="refundType">
                  <el-select class="" v-model="detailValue.refundType" placeholder="请选择退款方式" size="small">
                    <!-- <el-option v-for="(item, index) in getDict('Dept')" :key="index" :label="item.text" :value="item.code"></el-option> -->
                    <el-option v-for="(item, index) in [{text:'原渠道返回',code:'1'},{text:'现金',code:'2'}]" :key="index" :label="item.text" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              
            </el-row>
          </el-form>
        </div>
        <el-row style="margin-top: 20px; text-align: right;padding:0 110px;">
          <el-button  size="large" @click.native="$emit('update:visible', false)" class="w100">关闭</el-button>
          <el-button :loading="meta.loading" @click="submit" class="w100" type="primary" style="margin-left: 1rem;" size="large">结算</el-button>
          <br/>
          <br/>
          <el-checkbox v-model="checked">打印凭据</el-checkbox>
        </el-row>
      </div>
      <!-- <el-empty v-else description="暂无数据"></el-empty> -->
    </el-main>

  </el-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  components: {
    // comContent: () => import("./content"),
    // selectorStaff: () => import("@/components/_com/selectorStaff"),
  },
  props: {
    infoDetail:Object,
    visible: Boolean,
    isNew: Boolean,
  },
  data() {
    return {
      checked:false,
      detailValue:{},
      rules: {
        refundType: [
          { required: true, message: "请选择退款方式", trigger: "change" },
        ]
      },
      meta:{
        loading:false
      }
     
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "dictEnum","user", "permission"]),
    nowTime() {
      return new Date(); //this.$utils.fmtDateTime(new Date())
    },
  },
  filters:{
   
  },
  watch:{
  },
  mounted() {
    // this.detailValue = this.infoDetail
  },
  methods: {
    genderFlter(v){
      let info = this.dict.Gender.find((item)=>{
        return v == item.code
      })
      return ''
    },
    cancel() {
      clearTimeout(this.timer)
      this.$emit("close");
      this.$emit("update:visible", false);
    },
    async queryPatient(){
      if(!this.card.cardType){
        return  this.$message.error("请选择证据类型")
      }
      if(!this.card.cardNo){
        return this.$message.error("请输入证据号码")
      }
      this.meta.loading = true;

      api.getPatientByIdNo(this.card.cardNo,this.card.cardType).then((res)=>{
        if(res){
          this.isPatient = true
          this.patient = res
          this.getList()
        }else{
          this.isPatient = false
          this.patient = {}
        }
      }).catch((err)=>{
        console.log(1)
        this.$message.error(err.message || err);
      }).finally(()=>{
        // this.meta.loading = false;
      }) 
    },
    getList(){
      api.getInfusionList(this.patient.code,this.user.deptCode).then((res)=>{
        if(res.items && res.items.length>0){
          let _list = res.items
          let ids = []
          if(_list.length>0){
            _list.forEach(item =>{
              let count = 0
              let allNum = 0
              item.apList.forEach(value =>{
                if(value.app.state =='待执行' || value.app.state =='已执行'){// || value.app.state =='已拒绝'
                  count++
                  ids.push(value.app.id)
                }
                allNum++
              })
              item.count = count
              item.allNum = allNum
            })
          }

          this.tablist = _list
          this.tabContentList = _list[0].apList
          this.patient.opType = _list[0].apList[0].opType
          this.appIds = ids
        }else{
          
        }
      }).catch((err)=>{
        console.log(2)
        this.$message.error(err.message || err);
      }).finally(()=>{
        this.meta.loading = false;
      }) 
    },
    submit(){
      this.meta.loading = true;
      let data= {
        "ids":this.appIds,
        "recepterId":this.receivingUser.id,
        "recepterName":this.receivingUser.name,
        "seatCode":this.seatvalue?this.seatvalue[2]:"",
        "patientCode":this.patient.code,
        "patientName":this.patient.name,
        "patientGender":this.patient.gender,
        "patientAge":this.patient.patientAge,
        "deptCode":this.receivingUser.deptCode,
        "opType":this.patient.opType || "自费"
      }
      api.receivingOrder(data).then(res=>{
        this.receptionId = res.id
        this.$message.success('接单成功');
        this.$emit("update:isNew", false);
        
        this.refreshOrder()
      }).catch(error=>{
        console.log(3)
        this.$message.error(error.message || error);
      }).finally(()=>{
        this.meta.loading = false;
      })
    },
    finishAll(){
      this.$confirm("当前患者本次所有申请单执行完成，是否确认", "提示", { type: "warning",})
      .then(() => {
        if(this.execution && this.execution.type == '皮试'){
          return this.$message.error("请先结束皮试！")
        }
        api.finishAll(this.patient.id,this.user.deptCode).then(res=>{
          this.$message.success('完成成功')
          this.cancel()
        }).catch(error=>{

        }).finally(()=>{

        })
      })
      .catch((e) => {});
    },
  },
  beforeRouteLeave (to,from, next) {
    return next();
  }
};
</script>

<style scoped>
.redaK{
  background-color: #909399;
}
.tx-r{
  text-align: right;
}

.tx-l{
  text-align: left;
}
.tx-c{
  text-align: center;
}
.pall10p{
  padding: 10px;
}


.patientBox {
  height: 5rem;
  margin-bottom: 2rem;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0px;
}

.ztitle {
  margin-top: 10px;
  color: #66b1ff;
}
.inputnw .el-input {
  width: 4rem !important;
}
.inputDelW {
  width: 12rem;
}
.el-form--inline .el-form-item{
  margin-right: 0px;
}


</style>
<style>
.nobd .el-table__cell{
  border-right: none !important;
}
</style>
